import { getSharedConfig } from "../../createSharedConfig"
import { getBuyRequestMeta, getSimpleForBuyRequest } from "@/js/helpers/buy-request"
import { RACK_COLORS } from "@/js/pages/product/rackbuilder/constants"
import { RackOptions, FrontRackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getCommonAccessorySelections, getFrontSelection, getDepthSelection, getPlateStorageSelection } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"

export function createRhinoAddonConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const rack = findBundleProduct(rogue, buyRequest, 'rack') || getSimpleForBuyRequest(buyRequest, rogue)
  const functionalTrainer = findBundleProduct(rogue, buyRequest, 'trainer')

  const sharedConfig = getSharedConfig(rogue, buyRequest)
  const isHalfRack = rack?.attributes?.rack_size === '4'

  const addIndy = functionalTrainer?.attributes.rig_type?.toString().toLowerCase().includes('indy')
  const isRhinoRackTrainer = functionalTrainer?.attributes.rig_type === 'Rhino Rack Trainer'
  const leftSide = functionalTrainer?.attributes.side === 'Left' || functionalTrainer?.attributes.side === 'Dual'
  const rightSide = functionalTrainer?.attributes.side === 'Right' || functionalTrainer?.attributes.side === 'Dual'

  const { trolleySelection, lowRowSelection, latBarSelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  let backSelection: RackOptions['back'] = 'crossmember top 4'
  let frontSelection: FrontRackOptions = getFrontSelection(rogue, buyRequest, meta) || 'skinny'

  if (isHalfRack) {
    backSelection = ''
    frontSelection = 'crossmember top 4'
  } else if (sharedConfig.height === '100') {
    backSelection = 'nameplate'
  }

  return {
    ...sharedConfig,
    back             : backSelection,
    front            : frontSelection,
    edition          : 'rhino trainer',
    color            : RACK_COLORS['Rogue Red'],
    jcup             : '',
    depth            : getDepthSelection(rack, meta),
    sixPost          : !isHalfRack,
    plateStorage     : leftSide || rightSide ? getPlateStorageSelection(rogue, buyRequest) : undefined,
    storagePosts     : false,
    ghostRack        : false,
    ftShrouds        : rack?.attributes.rig_or_wm !== 'No',
    spotterArms      : getAccessoryQuantity(rogue, buyRequest, 'safety spotter'),
    frontStabilizer  : Boolean(findBundleProduct(rogue, buyRequest, 'half rack feet', true)),
    addIndy,
    leftSide,
    rightSide,
    isRhinoHalfRack  : isHalfRack,
    rhinoRackTrainer : isRhinoRackTrainer,
    trolleySelection,
    latBarSelection,
    lowRowSelection,
    isAddon          : true,
  }
}
